@if (showFloatingSection) {
    <div class="floating-contac contact-info px-medium md:flex mb-40px md:mb-60px lg:mb-90px">
        <div class="flex-row contact-info-left-side mr-50px xs:mb-10px flex">
            <div class="contact-info-gray-circle">
                <img src="../../../../assets/image/contact-image.png" alt="" />
            </div>
        </div>
        <div class="contact-info-right-side flex flex-col">
            <p class="fg-black pb20 body-copy mb0">
                <span>Kontakt</span>
            </p>
            <h2 class="fg-black header-medium mb0">
                <span> Har du spørgsmål til os?</span>
            </h2>
            <h2 class="fg-green header-medium mt0">
                <span [innerHTML]="'footer.support_text' | translate"></span>
                @if (telephoneLink$ | async; as link) {
                    <a class="fg-green nobr" (click)="onLinkClicked(link)" [href]="link.href" target="_blank">
                        {{ link.text }}
                    </a>
                }
            </h2>
        </div>
    </div>
}

<div class="footer p-medium bg-petroleum">
    <div class="flex-row flex-wrap flex">
        <div class="ph0 flex flex-col w-full md:w-1/2">
            <div class="footer__logo">
                <mat-icon svgIcon="evida_negativ" inline="true" aria-label="Evida logo"></mat-icon>
            </div>
        </div>
        <div class="footer__right-side ph0 flex flex-col w-full md:w-1/2">
            <h2 class="header-medium fg-green m0">
                {{ 'footer.distributionSlogan' | translate }}
            </h2>
        </div>
    </div>

    <div class="mt-30px md:mt-50px">
        <div class="flex flex-row flex-wrap gap-20px md:gap-0">
            <div class="ph0 flex flex-col w-full md:w-1/2">
                <p class="body-small fg-white m0 flex flex-col gap-3px">
                    <strong class="fg-white inline-block">
                        {{ 'shared.company.name' | translate }}
                    </strong>
                    <span>{{ 'shared.company.address' | translate }}</span>
                    <span>{{ 'shared.company.zip' | translate }} {{ 'shared.company.city' | translate }}</span>
                </p>
            </div>

            <div class="ph0 flex flex-col w-full md:w-1/2 max-width-container">
                <div class="mh0 flex flex-row justify-start">
                    <div class="ph0 flex flex-col w-auto">
                        <mat-nav-list dense class="information-label pt-0 evida-footer-nav-list">
                            @if (infoLinks$ | async; as infoLinks) {
                                <ul class="ul--blank">
                                    @for (link of infoLinks; track link) {
                                        <li>
                                            <a
                                                class="body-small fg-white"
                                                mat-menu-item
                                                [href]="link.href"
                                                target="_blank"
                                                (click)="onLinkClicked(link)"
                                            >
                                                {{ link.text }}
                                            </a>
                                        </li>
                                    }
                                </ul>
                            }
                        </mat-nav-list>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
